import { Routes } from '@angular/router'
import { DashboardPage } from '../pages/dashboard.page'
import { MsalGuard } from '@azure/msal-angular'
import { routesPageCanDeactivateGuard } from '../pages/routes-page.guard'

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'dashboard',
    pathMatch: 'full',
    component: DashboardPage,
    canActivate: [MsalGuard],
  },
  {
    path: 'routes',
    pathMatch: 'full',
    loadComponent: () => import('../pages/routes.page'),
    canActivate: [MsalGuard],
    canDeactivate: [routesPageCanDeactivateGuard],
  },
  {
    path: 'trips',
    pathMatch: 'full',
    loadComponent: () => import('../pages/trips.page'),
    canActivate: [MsalGuard],
  },
  {
    path: 'reports',
    loadComponent: () => import('../pages/reports.page'),
    canActivate: [MsalGuard],
  },
  {
    path: 'settings',
    pathMatch: 'full',
    loadComponent: () => import('../pages/settings.page'),
    canActivate: [MsalGuard],
  },
  {
    path: 'waze',
    pathMatch: 'full',
    loadComponent: () => import('../pages/waze.page'),
    canActivate: [MsalGuard],
  },
]
